<p-breadcrumb class="max-w-full" [model]="items">
    <ng-template pTemplate="item" let-item>
        <div
            class="flex align-items-center padding-4 radius-sm text-sm {{
                item.routerLink ? 'text-gray-300 hover:surface-300' : 'text-primary-700 font-medium'
            }}"
        >
            <span
                tooltipPosition="bottom"
                [pTooltip]="item?.label | translate"
                class="max-w-8rem w-full overflow-hidden white-space-nowrap text-overflow-ellipsis"
                >{{ item?.label | translate }}</span
            >
        </div>
    </ng-template>
    <ng-template pTemplate="separator">
        <img src="assets/icons/seperator.svg" height="14" width="10" alt="seperator" />
    </ng-template>
</p-breadcrumb>
